import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { SALES_DATA_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getProductSalesDataAction = createAsyncThunk(
    'price/getProductSalesDataAction',
    async (productId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ SALES_DATA_PATH }/${ productId }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getProductSalesDataSlice = createSlice({
    name: 'getProductSalesDataSlice',
    initialState: DEFAULT_STATE,
    extraReducers: builder => {
        builder.addCase(getProductSalesDataAction.pending, () => STATE__API__STARTED);
        builder.addCase(getProductSalesDataAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getProductSalesDataAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getProductSalesDataState = (state) => state.price.getProductSalesData;
export default getProductSalesDataSlice.reducer;